module.exports = __webpack_public_path__ + "static/logo-56555ba8a6d4aa34af94db834565b525.png";